import React, { useEffect, useState } from "react";
import "./ResultModal.css";

const ResultModal = ({
  showModal,
  onClose,
  testType,
  score,
  fullMark,
  passmark,
  lang,
}) => {
  const [progress, setProgress] = useState(0);
  const percentage = Math.round((score / fullMark) * 100);
  const passed = score >= passmark;

  useEffect(() => {
    if (showModal) {
      const timer = setTimeout(() => setProgress(percentage), 200);
      return () => clearTimeout(timer);
    } else {
      setProgress(0);
    }
  }, [showModal, percentage]);

  if (!showModal) return null;

  return (
    <div className="result-modal">
      <div className="result-modal-content">
        <div className="result-header">
          <h2>
            {lang === "bn"
              ? `${testType} সফলভাবে জমা দেওয়া হয়েছে!`
              : `${testType} Submitted Successfully!`}
          </h2>
        </div>

        <div className="result-progress-container">
          <svg className="result-progress-ring" viewBox="0 0 120 120">
            <circle
              className="result-ring-bg"
              cx="60"
              cy="60"
              r="54"
              strokeWidth="10"
            />
            <circle
              className="result-ring-fg"
              cx="60"
              cy="60"
              r="54"
              strokeWidth="10"
              style={{
                strokeDashoffset: 339.292 - (339.292 * progress) / 100,
              }}
            />
          </svg>
          <div className="result-progress-text">
            <h3 style={{ backgroundColor: "transparent" }}>{percentage}%</h3>
            <p>
              {score} / {fullMark}
            </p>
          </div>
        </div>

        <div className="result-message">
          {passed ? (
            <p className="result-passed">
              {lang === "bn"
                ? "অভিনন্দন! আপনি উত্তীর্ণ হয়েছেন।"
                : "Congratulations! You passed."}
            </p>
          ) : (
            <p className="result-failed">
              {lang === "bn"
                ? "দুঃখিত, আপনি পাশ হননি। আবার চেষ্টা করুন।"
                : "Sorry, you did not pass. Please try again."}
            </p>
          )}

          <p className="result-hint">
            {lang === "bn"
              ? "আপনার পরীক্ষার বিস্তারিত জানতে ইউজার উত্তর বিভাগ দেখুন।"
              : "Check your User Answer Section to find out more about your exam."}
          </p>
        </div>

        <button onClick={onClose} className="result-close-button">
          {lang === "bn" ? "বন্ধ করুন" : "Close"}
        </button>
      </div>
    </div>
  );
};

export default ResultModal;
